import { render } from "./CampaignsSettingView.vue?vue&type=template&id=6733600a&scoped=true"
import script from "./CampaignsSettingView.vue?vue&type=script&lang=js"
export * from "./CampaignsSettingView.vue?vue&type=script&lang=js"

import "./CampaignsSettingView.vue?vue&type=style&index=0&id=6733600a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6733600a"]])

export default __exports__